import store from '@/store';

const getStoreValue = (storeData, path) => {
  let value = storeData.state;

  path.split('.').forEach((key) => {
    value = value[key];
  });

  return value;
};

const conditionFromStore = (condition, storeKey) => (value) => {
  const storeValue = getStoreValue(store, storeKey);
  return condition(storeValue)(value);
};

export default conditionFromStore;
